<template>
    <NxSelect
    :value="localValue"
    :options="listOptions"
    labelText="Origens:"
    id="selectOrigem"
    placeholder="Selecione a(s) Origem(s)"
    :multiple="true"
    @update:value="handleValueUpdate"
  ></NxSelect>
</template>
<script>
import { toast } from '@/shared/utils/UIHelper'
import { useReactiveModelMixin } from '../../mixins'
import OriginRepository from '@/shared/http/repositories/configurations/origin.js'

export default {
  name: 'NxSelectOrigem',
  mixins: [ useReactiveModelMixin('value') ],
  data () {
    return {
      listOptions: [],
      selected: null
    }
  },
  created () {
    this.onLoadOrigens()
  },
  methods: {
    onLoadOrigens () {
      OriginRepository.GetAllActive()
        .then((response) => {
          let result = response.data.content
            .map((x) => ({'value': x.id, 'text': x.nome}))

          this.listOptions = result
        })
        .catch((err) => {
          toast.error('Não foi possível carregar a lista de Origens', 'Erro')
          console.error(err)
        })
    },
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectOrigem.vue